import { render } from "./GraficoTotalesCentro.vue?vue&type=template&id=2b8f2ef2"
import script from "./GraficoTotalesCentro.vue?vue&type=script&lang=js"
export * from "./GraficoTotalesCentro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__